'use es6';

import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { previewEditableAreas, universalEditableAreas } from 'customer-data-properties/savebar/EditableAreas';

/**
 * Context for holding which editable area constant should be used to store draft property changes.
 * This editable area must match the editable area that is watched by the save footer.
 * Editable areas: https://git.hubteam.com/HubSpot/customer-data-properties/blob/master/static/js/savebar/EditableAreas.js
 * Save bar wrapper used to watch the editable areas: https://git.hubteam.com/HubSpot/customer-data-properties/blob/master/static/js/savebar/SaveBarContainer.js
 *
 * @param {object}                                  editableAreas                     the area that should be watched for changes
 *
 */

export const EditableAreasContext = /*#__PURE__*/createContext(undefined);
EditableAreasContext.Provider.propTypes = {
  value: PropTypes.oneOf([universalEditableAreas, previewEditableAreas]).isRequired
};
export const useEditableAreasContext = () => useContext(EditableAreasContext);